import lity from 'lity';
import {
  AsYouType,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
  validatePhoneNumberLength

} from 'libphonenumber-js';

$(function () {
    // Patient Assessment
    var patient_assessment = {
        'dom': $('.patient-assessment'),
        'results': {
           'Length_of_pain__c': '',
           'Role_in_Journey__c': '',
           'Pain_Location__c' : '',
           'Pain_Level__c': '',
           'Treatment_Used__c' : '',
           'Functional_Limitations__c': '',
           'Patient_Gender__c': '',
           'Treatment_Stage__c': '',
           'Primary_Health_Insurance__c' : '',
           'Country' : ''
        },
        'user': {
            'first': '',
            'last': '',
            'email': '',
            'phone': '',
            'E164Phone__c': '',
            'zipcode': '',
            'timezone': ''
        },
        'current': 1,
        'popup': '',
        'uuid': '',
        'lastStep': $('.patient-assessment').data('last-step'),
        'gaconnector': {
            'all_traffic_sources': '',
            'fc_campaign': '',
            'fc_channel': '',
            'fc_content': '',
            'fc_landing': '',
            'fc_medium': '',
            'fc_referrer': '',
            'fc_source': '',
            'fc_term': '',
            'GA_Client_ID': '',
            'lc_campaign': '',
            'lc_channel': '',
            'lc_content': '',
            'lc_landing': '',
            'lc_medium': '',
            'lc_referrer': '',
            'lc_source': '',
            'lc_term': '',
            'page_visits': '',
            'time_passed': '',
            'device': '',
            'OS': '',
            'browser': '',
            'latitude': '',
            'longitude': ''
        },
        'phonetest': false,
        'userHighQuality': false,
        'userQualified': false,
        'userDisplayPhoneNumber': false,
        open: function () {
            this.popup = lity(this.dom);
            this.resetQuiz();

            //just check the query parameter. Forget about the cookie
            //Turn this on permanently: N2NCWM3-19
//          if(this.findGetParameter('abt')) {
                this.phonetest = true;
//          }

            // Submit GTM tag of start location for popup
            this.submitGTM('Patient Assessment Start Location', 'assessment-begin', window.location.href);
        },
        createCookie: function(name, value, days) {
            // Cookie setter function
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        },
        close: function () {
            // Submit GTM tag of end of popup
            this.submitGTM('Patient Assessment Exit', 'assessment-exit', window.location.href);
            this.popup.close();
            this.resetQuiz();
        },
        nextStep: function (questionKey, questionNumber) {
            let continueSteps = true;
            if(patientAssessmentValidationCountryCode == "United States"){
                if(questionKey =="Length_of_pain__c"){
                    if (!this.validateLength_of_pain__c()) {
                        this.dom.attr('data-step', 91);//special error condition
                        continueSteps = false;
                    }
                }else if (questionKey =="Pain_Level__c"){
                    if (!this.validatePain_Level__c()) {
                        this.dom.attr('data-step', 93);//special error condition
                        continueSteps = false;
                    }
                }else if (questionKey =="Primary_Health_Insurance__c"){
                    if (!this.validatePrimary_Health_Insurance__c()) {
                        this.dom.attr('data-step', 95);//special error condition
                        continueSteps = false;
                    }
                }
            }
            if(continueSteps){
                this.current++;
                if (this.current <=  patient_assessment.lastStep) {
                    this.updateQuiz();
                } else {
                    this.submitQuiz();
                }
            }
        },
        prevStep: function () {
            //TODO check the back logic
            var errorModalCheck = parseInt(this.dom.attr('data-step'));

            if (errorModalCheck == 93) {
                this.current = 3;
            } else if (errorModalCheck == 95) {
                this.current = 6;
            } else if (this.current > 1) {
                this.current--;
            }

            this.dom.removeClass('phonetest');//There is a lot of magic here

            $('#j-email-collection__form').show();
            $('#j-phone-confirmation-form').hide();
            $('#j-phone-confirmation-form').css('display',"none");

            if (this.current >=  (patient_assessment.lastStep + 1)) {
                this.current = (patient_assessment.lastStep + 1);
                this.updateQuiz();
                this.submitQuiz();
            }else{
                this.updateQuiz();
            }
        },
        updateQuiz: function () {
            // update the data attr to current step
            patient_assessment.dom.find('.patient-assessment--inner').scrollTop(0);
            if (this.dom.hasClass('patient-assessment__privacy') ) {
                this.dom.removeClass('patient-assessment__privacy');
            } else if (!(this.dom.hasClass('phonetest'))) {
                this.dom.removeClass('patient-assessment__approved patient-assessment__denied');
            }

            this.dom.attr('data-step', this.current);
        },
        resetQuiz: function () {
            // reset to first step
            this.current = 1;
            // remove status classes
            this.dom.removeClass('patient-assessment__approved patient-assessment__denied');
            // Clear stored results
            this.results = {
                'Length_of_pain__c': '',
                'Role_in_Journey__c': '',
                'Pain_Location__c' : '',
                'Pain_Level__c': '',
                'Treatment_Used__c' : '',
                'Functional_Limitations__c': '',
                'Patient_Gender__c': '',
                'Treatment_Stage__c': '',
                'Primary_Health_Insurance__c' : ''
            };
            // uncheck checkboxes
            this.dom.find('input[type="checkbox"]:checked').attr('checked', false);
            // update quiz
            this.updateQuiz();
        },
        saveResult: function (question, answer) {
            this.results[question] = answer;
        },
        submitGTM: function (question, questionSlug, answer) {
            patient_assessment.uuid = window.getCookie('visitorUUID');

            if (answer === 0 && questionSlug !== "rate-your-pain-level") {
                answer = "No";
            }
            if (answer === 1 && questionSlug !== "rate-your-pain-level") {
                answer = "Yes";
            }

            dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': '/patient-assessment/' + questionSlug,
                'virtualPageTitle': question,
                'answer': answer,
                'UUID': patient_assessment.uuid
            });
        },
        getTimezone: function (date) {
            return /\((.*)\)/.exec(date.toString())[1];
        },
        // validation ___________________///

        validateLength_of_pain__c: function () {
            // Question 2 must be "6 months to 1 year" or "More than 1 year"
            //return (this.results[2] === "6-12 months" || this.results[2] === "> 12 months");
            //SAME FOR USA && DE
            return (this.results["Length_of_pain__c"] === "6-12 months" || this.results["Length_of_pain__c"] === "> 12 months");//after question swap
        },


        //                          a          b           c           d            e            f         g      h        i      j         k            l   
        //  requiredElements = [ "Neck" ,"Upper Back" ,"Mid Back" ,"Lower Back" ,"Buttocks" ,"Groin" ,"Chest" ,"Belly" ,"Arms" ,"Legs" ,"Foot-Feet" ,"Other"];
        validatePain_Location__c: function () {
            var approval = false;

            if(patientAssessmentValidationCountryCode == "Germany" || patientAssessmentValidationCountryCode == "United States"){
                //                          a          b           c           d            e     g     i      j         k          l   
                var requiredElements = ["Neck","Upper Back","Mid Back","Lower Back","Buttocks","Chest","Arms","Legs","Foot-Feet","Other"];
            } else if(patientAssessmentValidationCountryCode == "Australia") {
                //                        c           d            e          i        j         k        
                requiredElements = [ "Mid Back" ,"Lower Back" ,"Buttocks"  ,"Arms" ,"Legs" ,"Foot-Feet" ];
            } else {
                return true;
            }

            var selectedElements = this.results['Pain_Location__c'];
            var commonElements   = requiredElements.filter(function (e) {
                return selectedElements.indexOf(e) > -1;
            });

            if (commonElements.length > 0) {
                approval = true;
            }

            return approval;
        },


        validatePrimary_Health_Insurance__c: function () {
            if( (patientAssessmentValidationCountryCode == "United States") &&  (this.results['Primary_Health_Insurance__c'] == "No Insurance/Self Pay")){
                return false;
            }else{
                return true;
            }
        },

        validatePain_Level__c: function () {
            // Question 4 must be a 4 or higher
            //
            return (this.results['Pain_Level__c'] > 3);// All locations as of NEV-92
        },
        validateFunctional_Limitations__c: function () {
            // Question 8 needs at least 1 choice
            // if(((patientAssessmentValidationCountryCode == "Germany") || (patientAssessmentValidationCountryCode == "Australia"))){
            if(patientAssessmentValidationCountryCode == "Germany"){
                return (this.results['Functional_Limitations__c'].length > 0);//USA && DE
            }else{
                return true;
            }
        },


        validateTreatment_Used__c: function () {

            if(((patientAssessmentValidationCountryCode == "Germany") || (patientAssessmentValidationCountryCode == "Australia"))){
                return true;
            }


            /*
            Options:
            a   Spine Injections
            b   Nerve ablation
            c   Back Surgery
            d   Minimally invasive spine procedure
            e   Spinal Cord Stimulator
            f   Implanted pain pump
            g   Physical therapy
            h   Chiropractic care
            i   TENS Unit
            j   Other
            */


            const therapyIncludes = [
              "Spine Injections",
              "Nerve ablation",
              "Back Surgery",
              "Minimally invasive spine procedure",
              "Spinal Cord Stimulator",
              "Implanted pain pump",
              "Implantable pain pump",
              "Physical therapy",
              "Chiropractic care",
              "TENS Unit"
            ];

            const therapyIncludesResults = this.results['Treatment_Used__c']
              .split(', ')
              .some(result => therapyIncludes.includes(result));

            return therapyIncludesResults;

        },
        // show phone number field for specific answers to question 8
        //LOGIC IS THE SAME FOR DE && USA
        //N2NCWE4-12
        displayPhoneNum: function () {


            var displayPhoneNumber = true;
            var therapyIncludes = ["Epidural Injections" ,"Nerve ablation" ,"Spine Surgery" ,"Spinal Cord Stimulation" ,"Spinal Cord Stimulator","Implanted pain pump" ,"Implantable pain pump" ,"Prescribed pain medications" ,"Physical therapy" ,"Chiropractic care" ,"TENS Unit" ,"Other"];

            //var therapyIncludes = ["Back Surgery" ,"Minimally invasive spine procedure"];

            // Don't show the phone number if question 5 answers include
            var therapyExcludes = [];
            //var therapyExcludes = ["Physical therapy", "Chiropractic care", "TENS Unit", "Other"];
            var insuranceExcludes = ["Medicaid", "No Insurance/Self Pay"];
            var Treatment_Used__cResults = this.results['Treatment_Used__c'].split(', ');
            var Primary_Health_Insurance__cResults = this.results['Primary_Health_Insurance__c'].split(', ');
            var therapyArr = [];

            if(patientAssessmentValidationCountryCode == "United States"){
//              therapyIncludes      = ["Back Surgery" ,"Minimally invasive spine procedure" ];//Treatment_Used__c
                therapyIncludes      = [ "Spine Injections" ,"Nerve ablation" ,"Back Surgery" ,"Minimally invasive spine procedure" ,"Spinal Cord Stimulator" ,"Implanted pain pump" ];//Treatment_Used__c
                insuranceExcludes    = [ "Medicaid" ,"No Insurance/Self Pay" ,"Unknown" ,"Other"];//Primary_Health_Insurance__c
            }

            Treatment_Used__cResults.forEach(function(result){
                therapyArr.push(therapyIncludes.includes(result));
            });

            var insuranceArr = [];
            Primary_Health_Insurance__cResults.forEach(function(result) {
                insuranceArr.push(insuranceExcludes.includes(result));
            });

            //Australia is good with any selection. No exclusions
            if (patientAssessmentValidationCountryCode != "Australia" && patientAssessmentValidationCountryCode != "Germany"){
                if (!therapyArr.includes(true) ) {
                    displayPhoneNumber = false;
                }
            }

            if (insuranceArr.includes(true) && !insuranceArr.includes(false)) {
                displayPhoneNumber = false;
            }
            this.userDisplayPhoneNumber = displayPhoneNumber;//store this for later
            return displayPhoneNumber;
        },

        approvePatient: function () {
            var approval = true;
            if (!this.validateLength_of_pain__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Question 2', 'assessment-unqualified', window.location.href);
            }
            if (!this.validatePain_Location__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Question 3', 'assessment-unqualified', window.location.href);
            }
            if (!this.validatePain_Level__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Question 4', 'assessment-unqualified', window.location.href);
            }

            if (!this.validateFunctional_Limitations__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Question 8', 'assessment-unqualified', window.location.href);
            }

            if (!this.validateTreatment_Used__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Question 5', 'assessment-unqualified', window.location.href);
            }
            return approval;
        },

        submitQuiz: function () {
            if (!this.displayPhoneNum()) {
                // hide phone field
                this.dom.find('#pa-input_phone').addClass('patient-assessment--question');
                this.dom.find("label[for='pa-input_phone']").addClass('patient-assessment--question');
                this.dom.find(".patient-assessment--phone-number-text").addClass('patient-assessment--question');
            } else {
                // unhide phone field
                this.dom.find('#pa-input_phone').removeClass('patient-assessment--question');
                this.dom.find("label[for='pa-input_phone']").removeClass('patient-assessment--question');
                this.dom.find(".patient-assessment--phone-number-text").removeClass('patient-assessment--question');
            }

            if (this.approvePatient()) {
                this.dom.removeClass('patient-assessment__denied').addClass('patient-assessment__approved');
                // Submit GTM tag when Quiz is approved
                this.submitGTM('Patient Assessment Qualified', 'assessment-qualified', window.location.href);
            } else {
                this.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');
                // Submit GTM tag when Quiz is denied
                this.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
            }
            this.dom.attr('data-step', this.current);
        },

        submitForm: function () {
            this.gatherUserInfo();
            this.gatherGAConnector();
            this.gatherCountryCode();

            if (this.validateForm()) {

     $('#j-email-collection__form').css('display',"none");
     $('#j-phone-confirmation-form').css('display',"none");
                this.dom.addClass('patient-assessment__privacy');
                // Submit GTM tag when Quiz is approved ///
                this.submitGTM('Patient Assessment Form Validated', 'form-complete', window.location.href);
            } else {
                this.submitGTM('Patient Assessment Form Not Validated', 'form-incomplete', window.location.href);
            }
        },
        checkEmailBeforeSubmittingForm: function() {
            this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');//clear the errors
            this.gatherUserInfo();
            if (this.validateForm()) {
                // Only show if part of B testing group, otherwise just submit regularly
                //
                if ( this.displayPhoneNum() && patient_assessment.phonetest
                       && (this.dom.find('.input--phone-number').length > 0)
                       && this.user.phone === '') {

                    $('#j-email-collection__form').hide();
                    $('#j-email-collection__form').css('display',"none");
                    $('#j-phone-confirmation-form').show();



                    this.dom.addClass('phonetest');//There is a lot of magic here
                } else {

                    $('#j-email-collection__form').css('display',"none");
                    $('#j-phone-confirmation-form').css('display',"none");
                    this.submitForm();
                }
            }
        },
        findGetParameter: function(parameterName) {
            var result = null,
                tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
                tmp = items[index].split("=");
                if (tmp[0] === parameterName) {
                    result = decodeURIComponent(tmp[1]);
                }
            }
            return result;
        },
        gatherUserInfo: function () {
            this.user.email = this.dom.find('.input--email').val().trim();
            this.user.first = this.dom.find('.input--first').val();
            this.user.last = this.dom.find('.input--last').val();
            this.user.birth = this.dom.find('.input--month').val() + '/' + this.dom.find('.input--day').val() + '/' + this.dom.find('.input--year').val();

            this.user.zipcode = this.dom.find('.input--zipcode').val().trim();
            this.user.timezone = this.getTimezone(new Date());
            if (this.dom.find('.input--phone-number').length > 0) {
                this.user.phone = this.dom.find('.input--phone-number').val();
                var path = window.location.pathname;
                if (this.user.phone !== '' && this.user.phone !== null && this.user.phone !== undefined && !path.includes('en-')) {
                dataLayer.push({
                    'event': 'phoneNumberAdded',
                    'UUID': patient_assessment.uuid
                    });
                }
            } else {
                this.user.phone = null;
            }
        },
        gatherCountryCode: function() {
            this.saveResult('Country', this.dom.find("input[name='patient_assessment_country']").val());
        },
        returnCountryCode: function() {
            this.gatherCountryCode();
            return this.results['Country'];
        },
        gatherGAConnector: function() {
            // this.gaconnector.all_traffic_sources = document.getElementsByName("all_traffic_sources")[0].value;
            this.gaconnector.all_traffic_sources = this.dom.find("input[name='all_traffic_sources']").val();
            this.gaconnector.fc_campaign = this.dom.find("input[name='fc_campaign']").val();
            this.gaconnector.fc_channel = this.dom.find("input[name='fc_channel']").val();
            this.gaconnector.fc_content = this.dom.find("input[name='fc_content']").val();
            this.gaconnector.fc_landing = this.dom.find("input[name='fc_landing']").val();
            this.gaconnector.fc_medium = this.dom.find("input[name='fc_medium']").val();
            this.gaconnector.fc_referrer = this.dom.find("input[name='fc_referrer']").val();
            this.gaconnector.fc_source = this.dom.find("input[name='fc_source']").val();
            this.gaconnector.fc_term = this.dom.find("input[name='fc_term']").val();
            this.gaconnector.GA_Client_ID = this.dom.find("input[name='GA_Client_ID']").val();
            this.gaconnector.lc_campaign = this.dom.find("input[name='lc_campaign']").val();
            this.gaconnector.lc_channel  = this.dom.find("input[name='lc_channel']").val();
            this.gaconnector.lc_content = this.dom.find("input[name='lc_content']").val();
            this.gaconnector.lc_landing = this.dom.find("input[name='lc_landing']").val();
            this.gaconnector.lc_medium = this.dom.find("input[name='lc_medium']").val();
            this.gaconnector.lc_referrer = this.dom.find("input[name='lc_referrer']").val();
            this.gaconnector.lc_source = this.dom.find("input[name='lc_source']").val();
            this.gaconnector.lc_term = this.dom.find("input[name='lc_term']").val();
            this.gaconnector.page_visits = this.dom.find("input[name='page_visits']").val();
            this.gaconnector.time_passed = this.dom.find("input[name='time_passed']").val();
            this.gaconnector.OS = this.dom.find("input[name='OS']").val();
            this.gaconnector.browser = this.dom.find("input[name='browser']").val();
            this.gaconnector.latitude = this.dom.find("input[name='latitude']").val();
            this.gaconnector.longitude = this.dom.find("input[name='longitude']").val();
            this.gaconnector.device = this.dom.find("input[name='device']").val();
        },
        firePixelEligible: function () {
            var path = window.location.pathname;
            // check to make sure we are only on the main US site
            if (patientAssessmentValidationCountryCode == "Germany" 
            || patientAssessmentValidationCountryCode == "Australia" 
            || patientAssessmentValidationCountryCode == "United States") {
                var firePixel = true;
                var therapyExcludes = ["Physical therapy", "Chiropractic care", "TENS Unit", "Other"];
                var insuranceExcludes = ["Medicaid", "No Insurance/Self Pay"];
                var question5Results = this.results['Treatment_Used__c'].split(', ');
                var question9Results = this.results['Primary_Health_Insurance__c'].split(', ');
                var therapyArr = [];
                question5Results.forEach(function(result){
                    therapyArr.push(therapyExcludes.includes(result));
                });
                //
                var insuranceArr = [];
                question9Results.forEach(function(result) {
                    insuranceArr.push(insuranceExcludes.includes(result));
                });
                // Don't show the phone number if question 5 answers include therapyExcludes
                if (therapyArr.includes(true) && !therapyArr.includes(false)) {
                    firePixel = false;
                }
                // Don't show the phone number if question 9 includes insuranceExcludes
                if (insuranceArr.includes(true) && !insuranceArr.includes(false)) {
                    firePixel = false;
                }


                if (firePixel) {
                    dataLayer.push({
                        'event': 'pixelEligible',
                        'UUID': patient_assessment.uuid
                    });
                }
            }
        },
        //HighQuality
        //switch up the text based on if they are high quality or not        
        displayTextHighQuality: function (highQuality, country) {
            //assume only 1 by this classname
            //flip on the green check mark for the USA
            if(country == "United States"){
                if(document.getElementsByClassName('icon-check-circle-hq')[0]){
                    document.getElementsByClassName('icon-check-circle-hq')[0].style.visibility = "visible";
                    document.getElementsByClassName('icon-check-circle-hq')[0].style.display = "block";
                }
                document.getElementsByClassName('icon-check-circle')[0].style.display = "none";
            }
            if(highQuality && country == "United States"){
                $('.patient-assessment--high-quality-web-lead').css({
                    visibility: 'visible',
                    display: 'block'
                });
                $('.patient-assessment--regular-web-lead').css('display', 'none');
            }else{
                document.getElementsByClassName('icon-check-circle')[0].style.visibility = "visible";
                document.getElementsByClassName('icon-check-circle')[0].style.display = "block";
                if(document.getElementsByClassName('icon-check-circle-hq')[0]){
                    document.getElementsByClassName('icon-check-circle-hq')[0].style.display = "none";
                }
                if(document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0].style.display = "none";
                }

                if(document.getElementsByClassName('patient-assessment--question-sub-title-usa patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title-usa patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0].style.display = "none";
                }
                if(document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.visibility = "visible";
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.display = "block";
                }
                if(document.getElementsByClassName('patient-assessment--question-sub-title-usa patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title-usa patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.visibility = "visible";
                    document.getElementsByClassName('patient-assessment--question-sub-title-usa patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.display = "block";
                }
  
            }
        },
        firePixelPAQualHighQuality: function () {
            var path = window.location.pathname;
            // check to make sure we are only on the main US site
            
            var firePixel = true;
            var Length_of_pain__c_value = false;//NEW 
            var Pain_Level__c_min = false;//NEW
            if (patientAssessmentValidationCountryCode    == "Germany" 
              || patientAssessmentValidationCountryCode   == "Australia"  
              || patientAssessmentValidationCountryCode   == "United States") {

                if(patientAssessmentValidationCountryCode == "Germany"){
                    //entire list: 
//                  var therapyIncludes      = ["Epidural Injections" ,"Nerve ablation" ,"Spine Surgery" ,"Spinal Cord Stimulation" ,"Implanted pain pump" ,"Physical therapy" ,"Chiropractic care" ,"TENS Unit" ,"Other"];
                    var therapyIncludes      = ["Epidural Injections" ,"Nerve ablation" ,"Spine Surgery" ,"Spinal Cord Stimulation" ,"Spinal Cord Stimulator" ,"Implanted pain pump" ,"Implantable pain pump"];
                    var insuranceExcludes    = [];
                    var painLocationIncludes = ["Neck","Upper Back","Mid Back","Lower Back","Buttocks","Chest",  "Legs","Arms",  "Foot-Feet", "Other" ];// DE 
                }else if(patientAssessmentValidationCountryCode == "United States"){
                    //N2NCWE4-12
                    Length_of_pain__c_value = "> 12 months";//NEW
                    Pain_Level__c_min       = 5;//NEW
                    var therapyIncludes      = ["Spine Injections" ,"Nerve ablation" ,"Back Surgery" ,"Minimally invasive spine procedure" ,"Spinal Cord Stimulation" , "Spinal Cord Stimulator","Implanted pain pump","Implantable pain pump"];//Treatment_Used__c
                    var insuranceExcludes    = [ "Medicaid" ,"No Insurance/Self Pay" ,"Unknown" ,"Other"];//Primary_Health_Insurance__c
                    var painLocationIncludes = ["Mid Back","Lower Back","Buttocks", "Legs",  "Foot-Feet" ];//Pain_Location__c_includes
                }else if(patientAssessmentValidationCountryCode == "Australia"){
                    var therapyIncludes      = ["Epidural Injections" ,"Nerve ablation" ,"Spine Surgery" ,"Spinal Cord Stimulation", "Spinal Cord Stimulator" ,"Implanted pain pump","Implantable pain pump" ,"Physical therapy" ,"Chiropractic care" ,"TENS Unit" ,"Other"];
                    var insuranceExcludes    = ["Medicare/Medicare Advantage", "Unknown"];
                    var painLocationIncludes = ["Mid Back","Lower Back","Buttocks", "Arms", "Legs",  "Foot-Feet" ];//Pain_Location__c_includes
                }else{
                    var therapyIncludes      = ["Epidural Injections" ,"Nerve ablation" ,"Spine Surgery" ,"Spinal Cord Stimulation" ,"Spinal Cord Stimulator" ,"Implanted pain pump","Implantable pain pump" ,"Physical therapy" ,"Chiropractic care" ,"TENS Unit" ,"Other"];
                    var insuranceExcludes    = ["Medicaid", "No Insurance/Self Pay"];//
                    var painLocationIncludes = false;// var aryPain_Location = this.results['Pain_Location__c'].split(",");
                }

                var Length_of_pain__c_result = this.results['Length_of_pain__c'];
                var Pain_Level__c_result     = this.results['Pain_Level__c_result'];

                var therapyIncludesResults = this.results['Treatment_Used__c'].split(', ');
                var question9Results = this.results['Primary_Health_Insurance__c'].split(', ');
                var aryPain_Location = this.results['Pain_Location__c'].split(', ');

                var therapyArr = [];
                therapyIncludesResults.forEach(function(result) {
                    therapyArr.push(therapyIncludes.includes(result));
                });

                var insuranceArr = [];
                question9Results.forEach(function(result) {
                    insuranceArr.push(insuranceExcludes.includes(result));
                });

                var requiredPainLocationFound = false;
                if(painLocationIncludes !== false){
                    requiredPainLocationFound = painLocationIncludes.some(item => aryPain_Location.includes(item));
                }else{
                    requiredPainLocationFound = true;
                }

                // mark it to fire if we find any of the pain locations 
                if (therapyArr.includes(true)  && requiredPainLocationFound) {
                    firePixel = true;
                    //But check if these tests need to be run and if they are vali d
                    if((Length_of_pain__c_value !== false) && (Pain_Level__c_min !== false)){ 
                        if(parseInt(Pain_Level__c_result) <= parseInt(Pain_Level__c_min)){
                            firePixel = false;
                        }
                        if( Length_of_pain__c_result !== Length_of_pain__c_value){
                            firePixel = false;
                        }
                    }
                }else{
                    firePixel = false;
                }

                // Don't fire the pixel if question 9 includes insuranceExcludes
                if (insuranceArr.includes(true) && !insuranceArr.includes(false)) {
                    firePixel = false;
                }
                //
                
                if (firePixel) {
                    this.userHighQuality = true;

                    dataLayer.push({
                        'event': 'PAQualHighQuality',
                        'UUID': patient_assessment.uuid
                    });
                }
                patient_assessment.displayTextHighQuality(firePixel, patientAssessmentValidationCountryCode);
            }
        },
        validateQuestionNextStepPainLocation: function (selections) {
            var status = true;
            if(selections.length === 0){
                status = false;
            }
            return status;
        },
        validateQuestionNextStepFunctional_Limitations__c: function (selections) {
            var status = true;
            if(selections.length === 0){
                status = false;
            }
            return status;
        },
        validateQuestionNextStepTreatmentsTried: function (selections) {
            var status = true;
            if(selections.length === 0){
                status = false;
            }
            return status;
        },
        validateForm: function () {
            var isValid = true;
            if (!this.validateNameFields()) {
                isValid = false;
                //this.submitGTM('Patient Assessment Form Not Validated -- Name Fields','form-incomplete', window.location.href );
            }
            if (!this.validateDateOfBirth()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Date Of Birth', 'form-incomplete', window.location.href);
            }
            if (!this.validateEmail()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Email', 'form-incomplete', window.location.href);
            }
            if (!this.validateZipCode()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Zip Code', 'form-incomplete', window.location.href);
            }
            if (!this.validatePhone()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Phone Number', 'form-incomplete', window.location.href);
            }
            return isValid;
        },
        testEmail: function (email) {
            var error_code = '';

            if (email.length === 0) {
                error_code = 0;
                return error_code;
            }

            if (email.indexOf('@') === -1) {
                error_code = email.indexOf('@');
                return error_code;
            }

            if (email.indexOf(' ') !== -1) {
                error_code = 1;
                return error_code;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(email)) {
                error_code = -2;
                return error_code;
            }
        },
        testZipCode: function (zipcode) {
            let error_code = '';
            if(patientAssessmentValidationCountryCode == "Australia"){
//              var re = /^[0-9]{4}/;
                var re = /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
            }else if(patientAssessmentValidationCountryCode == "Germany"){
                var re = /\d{5}-\d{4}$|^\d{5}$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
            }else if(patientAssessmentValidationCountryCode == "United States"){
                var re = /\d{5}-\d{4}$|^\d{5}$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
            }
            return error_code;
        },
        // validation ___________________///
        validateNameFields: function () {
            var result = true;
            if (this.user.first.trim().length < 1) {
                result = false;
                this.dom.find('.input--first').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- First Name', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--first').parents('.gfield').removeClass('has-error');
            }

            if (this.user.last.trim().length < 1) {
                result = false;
                this.dom.find('.input--last').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Last Name', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--last').parents('.gfield').removeClass('has-error');
            }
            return result;
        },
        validateDateOfBirth: function () {
            // First check for the pattern
            if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(this.user.birth)) {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Birth Year', 'form-incomplete', window.location.href);
                return false;
            }
            // Parse the date parts to integers
            var parts = this.user.birth.split("/");
            var day = parseInt(parts[1], 10);
            var month = parseInt(parts[0], 10);
            var year = parseInt(parts[2], 10);

            // Check the ranges of month and year
            if (year < 1000 || year > 3000 || month === 0 || month > 12) {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Birth Year', 'form-incomplete', window.location.href);
                return false;
            }

            var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            // Adjust for leap years
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                monthLength[1] = 29;
            }

            // Check the range of the day
            if (day > 0 && day <= monthLength[month - 1]) {
                this.dom.find('.input--year').parents('.gfield').removeClass('has-error');
                return true;
            } else {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                return false;
            }
        },
        validateEmail: function () {
            var result = true;
            var error_code = this.testEmail(this.user.email);
            var error_message = '';
            let countryCode = this.returnCountryCode();
            if(countryCode == 'Germany') {
                switch (error_code) {
                    case 0:
                        error_message = 'Bitte Email Adresse angeben';
                        break;
                    case -1:
                        error_message = 'Ein @ ist erforderlich';
                        break;
                    case 1:
                        error_message = 'Bitte Leerzeichen entfernen';
                        break;
                    default:
                        error_message = 'Bitte eine gültige E-Mail Adresse eingeben';
                }
            } else {
                switch (error_code) {
                    case 0:
                        error_message = 'Email address required';
                        break;
                    case -1:
                        error_message = 'An @ sign is required';
                        break;
                    case 1:
                        error_message = 'Please remove whitespace';
                        break;
                    default:
                        error_message = 'Please enter a valid email address';
                }
            }

            if (error_code <= 1) {
                result = false;
                this.dom.find('.input--email').parents('.gfield').addClass('has-error');
                this.dom.find("label[for='input_2_3'] > span").text(error_message);
            } else {
                this.dom.find('.input--email').parents('.gfield').removeClass('has-error');
            }

            return result;
        },
        validateZipCode: function () {
            var result = true;
            var error_code = this.testZipCode(this.user.zipcode);
            var error_message = "";

            if (this.user.zipcode.length < 1) {
                result = false;
                error_message = 'Zip Code required';
                this.dom.find('.input--zipcode').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Zip Code', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--zipcode').parents('.gfield').removeClass('has-error');
            }

            if (error_code === 2) {
                result = false;
                this.dom.find('.input--zipcode').parents('.gfield').addClass('has-error');
            } else {
                this.dom.find('.input--zipcode').parents('.gfield').removeClass('has-error');
            }
            return result;
        },
        validatePhone : function(){
            var result = true;

            if(this.user.phone.length > 0) {
                if(patientAssessmentValidationCountryCode == "United States"){
                    if( (this.user.phone.length > 0)  && !isValidPhoneNumber(this.user.phone, 'US') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Australia"){
                    if( (this.user.phone.length > 0)  && !isValidPhoneNumber(this.user.phone, 'AU') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Germany"){
                    if( (this.user.phone.length > 0)  && !isValidPhoneNumber(this.user.phone, 'DE') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else{
                    if(this.user.phone.length > 0 && this.user.phone.length > 20 ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }
            }
            return result;
        },
        checkExistingLead: function () {
            document.getElementsByClassName('patient-assessment--result patient-assessment--result__privacy')[0].style.visibility = "hidden";
            document.getElementsByClassName('patient-assessment--result patient-assessment--result__privacy')[0].style.display = "none";
            if(document.getElementsByClassName('patient-assessment--result__please-wait')[0]){
                document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.visibility = "visible";
            }
            if(document.getElementsByClassName('patient-assessment--result__please-wait')[0]){
                document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.display = "block";
            }

            var values = {
                "Email": this.user.email.trim(),
                "Phone": this.user.phone,
                "E164Phone__c": patient_assessment.formatPhoneNumber( this.user.phone, "E.164")
            };
            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'emailcheck'
                },
                success: function (response) {
                    if( response === 'survey exists' ){
                        patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
                        patient_assessment.dom.addClass('patient-assessment__survey__exists');
                        if(document.getElementsByClassName('patient-assessment--result__please-wait')[0]){
                            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.visibility = "hidden";
                            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.display = "none";
                        }
                        patient_assessment.submitGTM('Patient Assessment Update', 'survey-exists', window.location.href);
                    }
                    else if( response === 'no survey' ) {
                        //patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
                        //patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        patient_assessment.finalizeSubmission('update');
                    }
                    else{
                        patient_assessment.firePixelEligible();
                        //patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
                        //patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        patient_assessment.finalizeSubmission('new');
                    }
                }
            });
        },
        finalizeSubmission: function (task) {
            var values = {};
            // Submit GTM tag when Quiz is approved
            this.submitGTM('Patient Assessment Privacy Approved', 'submission-finalized', window.location.href);

            values = {
                "Task": task,
                "Email": this.user.email.trim(),
                "Patient_Time_zone__c": this.user.timezone,
                "All_Traffic_Sources__c": this.gaconnector.all_traffic_sources,
                "gaconnector_First_Click_Campaign__c": this.gaconnector.fc_campaign,
                "gaconnector_First_Click_Channel__c": this.gaconnector.fc_channel,
                "gaconnector_First_Click_Content__c": this.gaconnector.fc_content,
                "gaconnector_First_Click_Landing_Page__c": this.gaconnector.fc_landing,
                "gaconnector_First_Click_Medium__c": this.gaconnector.fc_medium,
                "gaconnector_First_Click_Referrer__c": this.gaconnector.fc_referrer,
                "gaconnector_First_Click_Source__c": this.gaconnector.fc_source,
                "gaconnector_First_Click_Term__c": this.gaconnector.fc_term,
                "gaconnector_Google_Analytics_Client_ID__c": this.gaconnector.GA_Client_ID,
                "gaconnector_Last_Click_Campaign__c": this.gaconnector.lc_campaign,
                "gaconnector_Last_Click_Channel__c": this.gaconnector.lc_channel,
                "gaconnector_Last_Click_Content__c": this.gaconnector.lc_content,
                "gaconnector_Last_Click_Landing_Page__c": this.gaconnector.lc_landing,
                "gaconnector_Last_Click_Medium__c": this.gaconnector.lc_medium,
                "gaconnector_Last_Click_Referrer__c": this.gaconnector.lc_referrer,
                "gaconnector_Last_Click_Source__c": this.gaconnector.lc_source,
                "gaconnector_Last_Click_Term__c": this.gaconnector.lc_term,
                "gaconnector_Number_of_Website_Visits__c": this.gaconnector.page_visits,
                "gaconnector_Time_Spent_on_Website__c": this.gaconnector.time_passed,
                "gaconnector_Operating_System__c": this.gaconnector.OS,
                "gaconnector_Browser__c": this.gaconnector.browser,
                "gaconnector_Latitude_from_IP__c": this.gaconnector.latitude,
                "gaconnector_Longitude__c": this.gaconnector.longitude,
                "Device__c": this.gaconnector.device
            };
            if (task === 'noupdate') {
                values.Request_for_patient_assessment__c = true;
            } else {
                var aryPain_Location = this.results['Pain_Location__c'].split(",");
                var aryTreatment_Used = this.results['Treatment_Used__c'].split(",");
                var aryFunctional_Limitations = this.results['Functional_Limitations__c'].split(",");

                values.FirstName = this.user.first;
                values.LastName = this.user.last;
                // values.Patient_Time_zone = this.user.timezone;
                values.Role_in_Journey__c                = this.results['Role_in_Journey__c'];
                values.Length_of_pain__c                 = this.results['Length_of_pain__c'];
                values.Pain_Location__c                  = aryPain_Location.join(";");
                values.Pain_Level__c                     = this.results['Pain_Level__c'];
                values.Treatment_Used__c                 = aryTreatment_Used.join(";");
                values.Functional_Limitations__c         = aryFunctional_Limitations.join(";");
                values.Treatment_Stage__c                = this.results['Treatment_Stage__c'];
                values.Patient_Gender__c                 = this.results['Patient_Gender__c'];
                values.PostalCode                        = this.user.zipcode;
                values.Phone                             = patient_assessment.formatPhoneNumber( this.user.phone, "NATIONAL");
                values.E164Phone__c                      = patient_assessment.formatPhoneNumber( this.user.phone, "E.164");
                values.Patient_DOB__c                    = this.user.birth;
                values.Request_for_patient_assessment__c = true;
                values.Primary_Health_Insurance__c       = this.results['Primary_Health_Insurance__c'];
                values.Country                           = this.results['Country'];
            }

            //different options for deciding if the user should see the pa-confirmation or confirmation page after submitting the form
            let localuserHighQuality = this.userHighQuality;// flag if the user was high quality 
            let localuserDisplayPhoneNumber  = this.userDisplayPhoneNumber;//flag if the user was offered the phone number
            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'pa-tool'
                },
                success: function (response) {
                    if ( (task === 'new' || task == 'update' || task == 'noupdate' ) && patientAssessmentValidationCountryCode == 'United States' ) {
                        if(localuserDisplayPhoneNumber === true){
                            window.location = '/pa-confirmation/';
                        }else{
                            window.location = '/confirmation/';
                        }
                    }
                    else if (response === 'update') {
                        patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy patient-assessment__survey__updated patient-assessment--result__survey-exists patient-assessment__survey__exists patient-assessment--result__survey__update');
                        patient_assessment.dom.addClass('patient-assessment__survey__updated');

                    }
                    else if (response === 'noupdate') {
                        patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy patient-assessment__survey__noupdated patient-assessment--result__survey-exists patient-assessment__survey__exists patient-assessment--result__survey__noupdate');
                        // hide last question
                        patient_assessment.dom.addClass('patient-assessment__survey__noupdated');
                    }
                    else {
                        patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
                        if((values.Country == "Australia") && (values.Phone.length > 1 )){
                            patient_assessment.dom.addClass('patient-assessment__survey__updated-phone-submitted');//this is how you trigger the special Australia only messaging for if the Australian user has submitted a phone numer
                            //patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        }else{
                            patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        }
                    }
                }
            });
        },
        downloadPDF: function () {
            var results = {
                'pain_score_results': patient_assessment.filterResultForDisplay(patient_assessment.results['Pain_Level__c']),
//              'duration_results': patient_assessment.filterResultForDisplay(patient_assessment.results[2]),
                'duration_results': patient_assessment.filterResultForDisplay(patient_assessment.results['Length_of_pain__c']),
                'pain_location_results': patient_assessment.filterResultForDisplay(patient_assessment.results['Pain_Location__c']),
                'other_remedies_results': patient_assessment.filterResultForDisplay(patient_assessment.results['Treatment_Used__c'])
            };

            var address = pdfGenerationURL + '?ps=' + results.pain_score_results + '&dur=' + results.duration_results + '&pl=' + results.pain_location_results + '&oth=' + results.other_remedies_results;
            window.open(encodeURI(address));
        },
        filterResultForDisplay: function (result) {
            return String(result).replace('Arms', 'Arm(s)')
                .replace('Legs', 'Leg(s)')
                .replace('Foot-Feet', 'Foot/Feet')
                .replace('Physical therapy', 'Physical Therapy')
                .replace('Implanted pain pump', 'Implantable Pain Pump');
        },



        formatPhoneNumber: function(inputPhoneNumber, phoneFormat){
            //this should be hard coded in the form at this point
            if(phoneFormat == "NATIONAL"){
                phoneFormat = "NATIONAL";
            }else if(phoneFormat == "E.164"){
                phoneFormat = "E.164";
            }else{
                phoneFormat = "NATIONAL";
            }
            //this should be hard coded in the form at this point
            let countryCode = this.returnCountryCode();
            if(countryCode == "United States"){
                let phoneNumber = new AsYouType('US').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'US') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'US');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Germany"){
                let phoneNumber = new AsYouType('DE').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'DE') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'DE');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Australia"){
                let phoneNumber = new AsYouType('AU').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'AU') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'AU');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else {
                return false;
            }
        }
    };

    //this is a bit of a global hack to gather the country code for the validation routines
    let patientAssessmentValidationCountryCode = patient_assessment.returnCountryCode();

    //////// ACTIONS /////////
    if (window.location.hash && window.location.hash === "#patient-assessment") {
        if (patient_assessment.dom.length > 0) {
            patient_assessment.open();
        }
    }

    // launch patient assessment test
    $(document).on('click', 'body .j-patient-assessment--open', function (e) {

        e.preventDefault();
        patient_assessment.open();
    });

    // Support for launching patient assessment from A/B test
    $(document).on('click', '.j-jump', function(e) {
        e.preventDefault();
        patient_assessment.open();
        const value = $(this).data('value');
        //assuming that length of pain is question 1
        patient_assessment.saveResult('Length_of_pain__c', value);
        $('.j-patient-assessment--input[data-value="' + value + '"]').click();
    });

    // check whether email already in SFDC as lead
    patient_assessment.dom.on('click', '.patient-assessment--privacy-submit', function () {
        $(this).prop('disabled', true).addClass('o-ajax-progress');
        if (patient_assessment.validatePhone() && (patient_assessment.user.phone.length > 0)) {
            dataLayer.push({
              'event': 'phoneNumberSubmitted',
              'UUID': patient_assessment.uuid
            });
        }
        patient_assessment.checkExistingLead();
    });

    // email detected, update SFDC lead
    patient_assessment.dom.on('click', '.patient-assessment--update--submit', function () {
        document.getElementsByClassName('patient-assessment--result patient-assessment--result__survey-exists')[0].style.visibility = "hidden";
        document.getElementsByClassName('patient-assessment--result patient-assessment--result__survey-exists')[0].style.display = "none";
        if(document.getElementsByClassName('patient-assessment--result__please-wait')[0]){
            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.visibility = "visible";
            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.display = "block";
        }
        patient_assessment.firePixelEligible();
        patient_assessment.finalizeSubmission('update');
    });

    // email detected, do NOT update SFDC lead
    patient_assessment.dom.on('click', '.patient-assessment--noupdate--submit', function () {
        document.getElementsByClassName('patient-assessment--result patient-assessment--result__survey-exists')[0].style.visibility = "hidden";
        document.getElementsByClassName('patient-assessment--result patient-assessment--result__survey-exists')[0].style.display = "none";

        if(document.getElementsByClassName('patient-assessment--result__please-wait')[0]){
            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.visibility = "visible";
            document.getElementsByClassName('patient-assessment--result__please-wait')[0].style.display = "block";
        }
        patient_assessment.finalizeSubmission('noupdate');
    });

    patient_assessment.dom.on('click', '.patient-assessment--close', function () {
        patient_assessment.close();
    });

    patient_assessment.dom.on('click', '.patient-assessment--back', function () {
        var _this = $(this);
        patient_assessment.prevStep();
    });

    patient_assessment.dom.on('click', '.j-patient-assessment--input', function () {
        var _this = $(this);
        patient_assessment.saveResult(_this.parents('.patient-assessment--question').data('key'), _this.data('value'));
        var results_container = '.patient-assessment--results-display-answer__' + _this.parents('.patient-assessment--question').data('question');
        $(results_container).html(patient_assessment.filterResultForDisplay(_this.data('value')));
        patient_assessment.submitGTM(
            _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
            _this.parents('.patient-assessment--question').data('question-slug'),
            _this.data('value')
        );
        if(_this.parents('.patient-assessment--question').data('key') === 'Primary_Health_Insurance__c'){
            patient_assessment.firePixelPAQualHighQuality();
        }
//      var container = _this.parents('.patient-assessment--question');

        //close the why are we asking this 
        _this.parents('.patient-assessment--question').find('.pa-answer').removeClass('pa-answer--open');
        _this.parents('.patient-assessment--question').find('.pa-why').removeClass('pa-why--closed');
        patient_assessment.nextStep(_this.parents('.patient-assessment--question').data('key'), _this.parents('.patient-assessment--question').data('question'));
    });

    patient_assessment.dom.on('keypress', '.j-patient-assessment--input', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.j-patient-assessment--next-step', function (e) {
        
//      this.dom.find('.pa-answer').removeClass('pa-answer--open');
//      this.dom.find('.pa-why').removeClass('pa-why--closed');
        e.preventDefault();
        var _this = $(this);
        var container = _this.parents('.patient-assessment--question');

        //close the why are we asking this 
        container.find('.pa-answer').removeClass('pa-answer--open');
        container.find('.pa-why').removeClass('pa-why--closed');

        var selections = container.find('input[type="checkbox"]:checked').map(function () {
            return $(this).val();
        }).get().join(", ");

        var moveOntoNext = true;
        var questionKey =_this.parents('.patient-assessment--question').data('key');
        if( (questionKey == "Pain_Location__c") && !patient_assessment.validateQuestionNextStepPainLocation(selections)){
            document.getElementById('validateQuestionNextStepPainLocation').style.visibility = "visible";
            //error messages to client
            moveOntoNext = false;
        }
        if((questionKey == "Functional_Limitations__c") && !patient_assessment.validateQuestionNextStepFunctional_Limitations__c(selections)){
            //error messages to client
            document.getElementById('validateQuestionNextStepFunctional_Limitations__c').style.visibility = "visible";
            moveOntoNext = false;
        }
        if((questionKey == "Treatment_Used__c") && !patient_assessment.validateQuestionNextStepTreatmentsTried(selections)){
            //error messages to client
            document.getElementById('validateQuestionNextStepTreatmentsTried').style.visibility = "visible";
            moveOntoNext = false;
        }
        if(moveOntoNext){
            document.getElementById('validateQuestionNextStepPainLocation').style.visibility = "hidden";
            document.getElementById('validateQuestionNextStepTreatmentsTried').style.visibility = "hidden";
            if(document.getElementById('validateQuestionNextStepFunctional_Limitations__c')){
                document.getElementById('validateQuestionNextStepFunctional_Limitations__c').style.visibility = "hidden";
            }
            patient_assessment.saveResult(_this.parents('.patient-assessment--question').data('key'), selections);
            var results_container = '.patient-assessment--results-display-answer__' + _this.parents('.patient-assessment--question').data('question');
            $(results_container).html(patient_assessment.filterResultForDisplay(selections));
            patient_assessment.submitGTM(
                _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                _this.parents('.patient-assessment--question').data('question-slug'),
                selections
            );
            patient_assessment.nextStep(_this.parents('.patient-assessment--question').data('key'), _this.parents('.patient-assessment--question').data('question'));
        }
    });

    patient_assessment.dom.on('keypress', '.j-patient-assessment--next-step', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.patient-assessment--checkbox', function () {
        var _this = $(this);
        var parent = _this.parents('.patient-assessment--question-content');
        if (_this.hasClass('patient-assessment--checkbox__none')) {
            if (_this.prop('checked') !== false) {
                parent.find('.patient-assessment--checkbox:not(.patient-assessment--checkbox__none)').find('input').prop('checked', false);
            }
        } else {
            parent.find('.patient-assessment--checkbox__none').find('input').prop('checked', false);
        }
    });

    patient_assessment.dom.on('keypress', '.patient-assessment--checkbox', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).find('label').trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.j-patient-assessment--start-over', function () {
        patient_assessment.resetQuiz();
    });

    patient_assessment.dom.on('keypress', '.j-patient-assessment--start-over', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.patient-assessment--submit-force', function (e) {
        patient_assessment.current++;
        patient_assessment.dom.attr('data-step', patient_assessment.current);
        e.preventDefault();
        patient_assessment.submitForm();
    });

    patient_assessment.dom.on('click', '#patient-assessment--submit', function (e) {

        patient_assessment.current++;
        patient_assessment.dom.attr('data-step', patient_assessment.current);
        e.preventDefault();
        patient_assessment.checkEmailBeforeSubmittingForm();
    });

    patient_assessment.dom.on('click', '.patient-assessment--submit-force-usa', function (e) {

        patient_assessment.current++;
        patient_assessment.dom.attr('data-step', patient_assessment.current);
        e.preventDefault();
        patient_assessment.submitForm();
    });

    patient_assessment.dom.on('click', '#patient-assessment--submit-usa', function (e) {
        patient_assessment.current++;
        patient_assessment.dom.attr('data-step', patient_assessment.current);
        e.preventDefault();
        patient_assessment.checkEmailBeforeSubmittingForm();
    });


    // DOWNLOAD PDF
    patient_assessment.dom.on('click', '.j-patient-assessment--download-pdf', function (e) {
        e.preventDefault();
        patient_assessment.downloadPDF();
    });

    patient_assessment.dom.on('paste', '#pa-input_phone', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
        },  1000);
    });

    patient_assessment.dom.on('paste', '#pa-input_phone2', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone2").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
            $("#pa-input_phone2").val(delayFormat);
        }, 1000);
    });

    patient_assessment.dom.on('keyup', '#pa-input_phone', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
        },  1000);
    });

    patient_assessment.dom.on('keyup', '#pa-input_phone2', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone2").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
            $("#pa-input_phone2").val(delayFormat);
        }, 1000);
    });
    $("#mytestinput-AU").keyup(function () {
        //this should be hard coded in the form at this point
        var _this = $("#mytestinput-AU");
        var phoneNumber = new AsYouType('AU').input(_this.val());
        if(isValidPhoneNumber(phoneNumber, 'AU') ){
            const phoneNumberParser = parsePhoneNumber(phoneNumber, 'AU');
            phoneNumber = phoneNumberParser.format("NATIONAL");
            //phoneNumber = phoneNumberParser.format("NATIONAL");
            _this.val(phoneNumber);
            $("#mytestinput-AU-results").val('VALID');
        }else{
            _this.val(phoneNumber);
            $("#mytestinput-AU-results").val('NOT VALID');
        }
    });

    $("#mytestinput-DE").keyup(function () {
        //this should be hard coded in the form at this point
        var _this = $("#mytestinput-DE");
        var phoneNumber = new AsYouType('DE').input(_this.val());
        if(isValidPhoneNumber(phoneNumber, 'DE') ){
            const phoneNumberParser = parsePhoneNumber(phoneNumber, 'DE');
            phoneNumber = phoneNumberParser.format("NATIONAL");
            //phoneNumber = phoneNumberParser.format("NATIONAL");
            _this.val(phoneNumber);
            $("#mytestinput-DE-results").val('VALID');
        }else{
            _this.val(phoneNumber);
            $("#mytestinput-DE-results").val('NOT VALID');
        }
    });

    $("#mytestinput-US").keyup(function () {
        //this should be hard coded in the form at this point
        var _this = $("#mytestinput-US");
        var phoneNumber = new AsYouType('US').input(_this.val());
        if(isValidPhoneNumber(phoneNumber, 'US') ){
            const phoneNumberParser = parsePhoneNumber(phoneNumber, 'US');
            phoneNumber = phoneNumberParser.format("NATIONAL");
            //phoneNumber = phoneNumberParser.format("NATIONAL");
            _this.val(phoneNumber);
            $("#mytestinput-US-results").val('VALID');
        }else{
            _this.val(phoneNumber);
            $("#mytestinput-US-results").val('NOT VALID');
        }
    });

    patient_assessment.dom.on('click', '.j-pa-why', function (e) {
        e.preventDefault();
        $(this).next().addClass('pa-answer--open');
        $(this).addClass('pa-why--closed');
    })

    patient_assessment.dom.on('click', '.j-pa-close', function (e) {
        e.preventDefault();
        $('.pa-answer').removeClass('pa-answer--open');
        $('.pa-answer').prev().removeClass('pa-why--closed');
/**
        $(this).parent('.pa-answer').removeClass('pa-answer--open');
        $(this).parent('.pa-answer').prev().removeClass('pa-why--closed');
*/
    })

});
